/**
 * NOTE: This file is compiled into vendor.js via gulp. "gulp --production" only allows ES5, so no "const",
 * arrow functions, etc.
 */

// Needs to be set as Symfony requests use this header to determine if it is an ajax request or not
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-Client-Id-Token'] = (document.querySelector('meta[name="client-id-token"]') || {}).content;

// Per env XSRF cookie name config to avoid cookie bomb/bashing
if(window.fundmetric && window.fundmetric._config) {
    axios.defaults.xsrfCookieName = window.fundmetric._config.xsrf_cookie || 'XSRF-TOKEN';
}

jQuery.ajaxSetup({
    headers: { 
        'X-Client-Id-Token': (document.querySelector('meta[name="client-id-token"]') || {}).content,
    }
});

// Global Helper function for hooking onto supporting object structures for the UI - Mainly just picklists so far
function formHelpers() {
    return {
        picklists: {
            years: _.range(1900, (new Date()).getFullYear() + 1),
            wealth_ranges: [
                {
                    min: 0,
                    max: 25000
                },
                {
                    min: 25000,
                    max: 50000
                },
                {
                    min: 50000,
                    max: 75000
                },
                {
                    min: 75000,
                    max: 100000
                },
                {
                    min: 100000,
                    max: 250000
                },
                {
                    min: 250000,
                    max: 500000
                },
                {
                    min: 500000,
                    max: 1000000
                },
                {
                    min: 1000000,
                    max: 5000000
                },
                {
                    min: 5000000,
                    max: 10000000
                },
                {
                    min: 10000000,
                    max: 50000000
                },
                {
                    min: 500000000,
                    max: 1000000000
                },
                {
                    min: 1000000000,
                    max: null
                }
            ],
            social_services: [
                {
                    id: 'facebook',
                    icon: 'facebook square',
                    name: 'Facebook'
                },
                {
                    id: 'twitter',
                    icon: 'twitter',
                    name: 'Twitter'
                },
                {
                    id: 'linkedin',
                    icon: 'linkedin',
                    name: 'Linkedin'
                },
                {
                    id: 'youtube',
                    icon: 'youtube',
                    name: 'YouTube'
                },
                {
                    id: 'googleprofile',
                    icon: 'google',
                    name: 'Google'
                },
                {
                    id: 'googleplus',
                    icon: 'google plus square',
                    name: 'Google+'
                },
                {
                    id: 'flickr',
                    icon: 'flickr',
                    name: 'Flickr'
                },
                {
                    id: 'quora',
                    icon: '',
                    name: 'Quora'
                },
                {
                    id: 'flickr',
                    icon: 'flickr',
                    name: 'Flickr'
                },
                {
                    id: 'foursquare',
                    icon: 'foursquare',
                    name: 'Foursquare'
                },
                {
                    id: 'klout',
                    icon: '',
                    name: 'Klout'
                },
            ]
        }
    };
}

/**
 * Add global semantic-ui validation rule "greaterThan"
 *
 * Usage: {type: "greaterThan[5]", prompt: "The amount should be more than $5.00"}
 *
 * @param inputValue
 * @param validationValue
 * @returns {boolean}
 */
$.fn.form.settings.rules.greaterThan = function (inputValue, validationValue) {
    return parseFloat(inputValue) >= parseFloat(validationValue);
};

/**
 * Add global semantic-ui validation rule "lessThan"
 *
 * Usage: {type: "lessThan[1000.00]", prompt: "The number should be less than 1000.00"}
 *
 * @param inputValue
 * @param validationValue
 * @returns {boolean}
 */
$.fn.form.settings.rules.lessThan = function (inputValue, validationValue) {
    return parseFloat(inputValue) <= parseFloat(validationValue);
};

/**
 * Override global default semantic-ui "url" rule, to allow "mailto:" and "tel:" urls
 * 
 * @param {*} inputValue 
 * @param {*} validationValue 
 * @returns {boolean}
 */
$.fn.form.settings.rules.url = function (inputValue, validationValue) {
    return [
        'http://',
        'https://',
        'mailto:',
        'tel:'
    ].some(function (allowStr) { return inputValue.startsWith(allowStr); });
};

/**
 * Add global semantic-ui validation rule "atLeastOneSelected"
 * Checks if an array has at least one row with a non-empty value for the specified attribute.
 *
 * Usage: {type: "atLeastOneSelected[designation_id]", prompt: "Please select at least one designation"}
 *
 * @param value - The field value (JSON string or array of objects)
 * @param attrName - The attribute name to check for non-empty values (e.g., "designation_id")
 * @returns {boolean}
 */
$.fn.form.settings.rules.atLeastOneSelected = function (value, attrName) {
    attrName = attrName || 'designation_id';
    // Parse JSON string if needed (hidden input stores as JSON string)
    var parsedValue = value;
    if (typeof value === 'string') {
        try {
            parsedValue = JSON.parse(value);
        } catch (e) {
            return false; // Can't parse, fail validation
        }
    }

    if (Array.isArray(parsedValue)) {
        return parsedValue.filter(function (row) {
            return row[attrName] && row[attrName] !== '';
        }).length >= 1;
    }
    return false;
};

/**
 * Add global semantic-ui validation rule "minRows"
 * Checks if an array has at least N rows with a non-empty value for the specified attribute.
 *
 * Usage: {type: "minRows[designation_id..2]", prompt: "Please select at least 2 designations"}
 *
 * @param value - The field value (JSON string or array of objects)
 * @param attrName - The attribute name to check for non-empty values (e.g., "designation_id")
 * @param minCount - The minimum number of valid rows required
 * @returns {boolean}
 */
$.fn.form.settings.rules.minRows = function (value, attrName, minCount) {
    // Parse JSON string if needed (hidden input stores as JSON string)
    var parsedValue = value;
    if (typeof value === 'string') {
        try {
            parsedValue = JSON.parse(value);
        } catch (e) {
            return false; // Can't parse, fail validation
        }
    }

    if (Array.isArray(parsedValue)) {
        var validRows = parsedValue.filter(function (row) {
            return row[attrName] && row[attrName] !== '';
        });
        return validRows.length >= parseInt(minCount);
    }
    return false;
};

/**
 * Add global semantic-ui validation rule "maxRows"
 * Checks if an array has at most N rows with a non-empty value for the specified attribute.
 *
 * Usage: {type: "maxRows[designation_id..5]", prompt: "Please select at most 5 designations"}
 *
 * @param value - The field value (JSON string or array of objects)
 * @param attrName - The attribute name to check for non-empty values (e.g., "designation_id")
 * @param maxCount - The maximum number of valid rows allowed
 * @returns {boolean}
 */
$.fn.form.settings.rules.maxRows = function (value, attrName, maxCount) {
    // Parse JSON string if needed (hidden input stores as JSON string)
    var parsedValue = value;
    if (typeof value === 'string') {
        try {
            parsedValue = JSON.parse(value);
        } catch (e) {
            return true; // Can't parse, pass validation (maxRows shouldn't block on parse error)
        }
    }

    if (Array.isArray(parsedValue)) {
        var validRows = parsedValue.filter(function (row) {
            return row[attrName] && row[attrName] !== '';
        });
        return validRows.length <= parseInt(maxCount);
    }
    return true; // If not array, pass validation
};

/**
 * Add global semantic-ui validation rule "splitAmountsMatch"
 * Validates that split amounts (from designation_amounts field) sum to the total donation amount.
 * Includes ALL splits with positive amounts (including "No Designation" with designation_id='0').
 *
 * Usage: {type: "splitAmountsMatch[amount]", prompt: "Split amounts must equal the total donation amount"}
 *
 * @param value - The field value (JSON string or array of {designation_id, amount} objects)
 * @param totalFieldName - The name of the field containing the total amount (e.g., "amount")
 * @returns {boolean}
 */
$.fn.form.settings.rules.splitAmountsMatch = function (value, totalFieldName) {
    // Parse JSON string if needed (hidden input stores as JSON string)
    var parsedValue = value;
    if (typeof value === 'string') {
        try {
            parsedValue = JSON.parse(value);
        } catch (e) {
            return true; // Can't parse, skip validation
        }
    }

    // Get the total amount from the form
    var $form = $(this).closest('form');
    var totalAmountField = $form.find('[name="' + totalFieldName + '"]');
    var totalAmount = parseFloat(totalAmountField.val()) || 0;

    // If no splits or not an array, skip validation (other rules handle required)
    if (!Array.isArray(parsedValue) || parsedValue.length === 0) {
        return true;
    }

    // Filter to only splits with designation_id set (including '0' for "No Designation") AND positive amount
    // Note: '0' is valid for "No Designation", but empty string is not
    var validSplits = parsedValue.filter(function (row) {
        var hasDesignation = row.designation_id !== undefined && row.designation_id !== null && row.designation_id !== '';
        var amount = parseFloat(row.amount) || 0;
        var hasPositiveAmount = amount > 0;
        return hasDesignation && hasPositiveAmount;
    });

    // If no valid splits after filtering, skip (other validation handles "at least one required")
    if (validSplits.length === 0) {
        return true;
    }

    // Check if there's at least one real designation (not '0')
    var realDesignationSplits = validSplits.filter(function (row) {
        return row.designation_id !== '0' && row.designation_id !== 0;
    });

    // If only one split with a real designation, it should match total (but allow minor tolerance)
    // For single split, we normalize on backend, so just check it's reasonable
    if (realDesignationSplits.length === 1 && validSplits.length === 1) {
        var singleAmount = parseFloat(validSplits[0].amount) || 0;
        // Allow if single amount equals total, or if total is 0 (will be set from amount)
        return totalAmount === 0 || Math.abs(singleAmount - totalAmount) <= 0.01;
    }

    // For multiple splits (or splits including "No Designation"), sum must equal total
    var splitSum = validSplits.reduce(function (sum, row) {
        return sum + (parseFloat(row.amount) || 0);
    }, 0);

    // Allow small tolerance for floating point
    return Math.abs(splitSum - totalAmount) <= 0.01;
};

/**
 * Add global semantic-ui validation rule "hasPositiveAmountSplit"
 * Validates that ALL splits have a positive amount (greater than $0).
 *
 * Usage: {type: "hasPositiveAmountSplit", prompt: "All designations must have an amount greater than $0"}
 *
 * @param value - The field value (JSON string or array of {designation_id, amount} objects)
 * @returns {boolean}
 */
$.fn.form.settings.rules.hasPositiveAmountSplit = function (value) {
    // Parse JSON string if needed (hidden input stores as JSON string)
    var parsedValue = value;
    if (typeof value === 'string') {
        try {
            parsedValue = JSON.parse(value);
        } catch (e) {
            return false; // Can't parse, fail validation
        }
    }

    // No splits to validate - pass validation (use minDesignations rule if at least one is required)
    if (!Array.isArray(parsedValue) || parsedValue.length === 0) {
        return true;
    }
    // Check that ALL splits have positive amount
    return parsedValue.every(function (row) {
        var amount = parseFloat(row.amount) || 0;
        return amount > 0;
    });
};

/**
 * Add global semantic-ui validation rule "minDesignations"
 * Checks if an array has at least N rows with a valid designation_id.
 * Used by form builder's ValidationModal for designation-amounts fields.
 *
 * Usage: {type: "minDesignations[2]", prompt: "Please select at least 2 designations"}
 *
 * @param value - The field value (JSON string or array of objects)
 * @param minCount - The minimum number of valid rows required
 * @returns {boolean}
 */
$.fn.form.settings.rules.minDesignations = function (value, minCount) {
    // Parse JSON string if needed (hidden input stores as JSON string)
    var parsedValue = value;
    if (typeof value === 'string') {
        try {
            parsedValue = JSON.parse(value);
        } catch (e) {
            return false; // Can't parse, fail validation
        }
    }

    if (Array.isArray(parsedValue)) {
        var validRows = parsedValue.filter(function (row) {
            return row.designation_id && row.designation_id !== '' && row.designation_id !== '0';
        });
        return validRows.length >= parseInt(minCount);
    }
    return false;
};

/**
 * Add global semantic-ui validation rule "maxDesignations"
 * Checks if an array has at most N rows with a valid designation_id.
 * Used by form builder's ValidationModal for designation-amounts fields.
 *
 * Usage: {type: "maxDesignations[5]", prompt: "Please select at most 5 designations"}
 *
 * @param value - The field value (JSON string or array of objects)
 * @param maxCount - The maximum number of valid rows allowed
 * @returns {boolean}
 */
$.fn.form.settings.rules.maxDesignations = function (value, maxCount) {
    // Parse JSON string if needed (hidden input stores as JSON string)
    var parsedValue = value;
    if (typeof value === 'string') {
        try {
            parsedValue = JSON.parse(value);
        } catch (e) {
            return true; // Can't parse, pass validation (maxDesignations shouldn't block on parse error)
        }
    }

    if (Array.isArray(parsedValue)) {
        var validRows = parsedValue.filter(function (row) {
            return row.designation_id && row.designation_id !== '' && row.designation_id !== '0';
        });
        return validRows.length <= parseInt(maxCount);
    }
    return true; // If not array, pass validation
};

// AIDEV-NOTE: every Semantic modal, on every bundle, gets these defaults: no dimmer-click close, Escape presses
// the modal's own cancel / deny / close control, and an open modal is refreshed whenever its own size changes.
(function ($) {
    if (!$.fn.modal) {
        return;
    }

    // A click on the dimmer no longer closes a modal (closable also gates Semantic's own Escape handling).
    $.fn.modal.settings.closable = false;

    // Escape presses the top open modal's own control, so it closes the way a click would (onDeny still runs).
    // Capture phase: an open dropdown or popup inside the modal still gets Escape first and keeps the modal open.
    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' && event.keyCode !== 27) {
            return;
        }
        const $modal = $('.ui.dimmer.modals .ui.modal.active').last();
        if (!$modal.length || $modal.find('.ui.dropdown > .menu.visible, .ui.popup.visible').filter(':visible').length) {
            return;
        }
        const $control = $modal.children('.actions').find('.cancel, .deny').add($modal.children('.close'))
            .filter(':visible').not('.disabled, :disabled').first();
        if ($control.length) {
            event.preventDefault();
            $control.trigger('click');
        }
    }, true);

    if (typeof ResizeObserver === 'undefined') {
        return;
    }

    // observeChanges only sees nodes added or removed; this also catches v-show sections, textareas and images.
    const observer = new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
            const el = entry.target;
            clearTimeout(el.fmModalRefresh);
            el.fmModalRefresh = setTimeout(function () {
                const $modal = $(el);
                // Calling .modal() on an uninitialized element would initialize it with defaults. Animating too:
                // Semantic measures at the start of show, so content landing during the open animation needs this.
                if ($modal.data('module-modal') && ($modal.modal('is active') || $modal.modal('is animating'))) {
                    $modal.modal('refresh');
                }
            }, 50);
        });
    });

    const semanticModal = $.fn.modal;
    $.fn.modal = function (behavior) {
        const result = semanticModal.apply(this, arguments);
        if (behavior === 'show' || behavior === 'toggle') {
            this.each(function () { observer.observe(this); });
        } else if (behavior === 'hide' || behavior === 'destroy') {
            this.each(function () { observer.unobserve(this); });
        }
        return result;
    };
    // Same settings object, so per-page code that reads or changes $.fn.modal.settings keeps working.
    $.extend($.fn.modal, semanticModal);
}(jQuery));
